import type { StoredSectorTemplate } from '../api/keycloak-admin/org-config';
import { deepCloneWithNewIds } from '../utils/org-tree-helpers';
import { getMilitarySeedTemplates } from './seed-templates-military';
import { getCivilianSeedTemplates } from './seed-templates-civilian';

/**
 * Get all built-in seed templates with fresh UUIDs.
 * Each call returns deep clones so templates can be safely mutated.
 */
export function getSeedTemplates(): StoredSectorTemplate[] {
  const all = [...getMilitarySeedTemplates(), ...getCivilianSeedTemplates()];
  return all.map((t) => ({
    ...t,
    id: crypto.randomUUID(),
    tree: deepCloneWithNewIds(t.tree),
  }));
}
